import { create } from 'zustand'

const STORAGE_KEY = 'betontasdash.cash-firm'

function read(): string | undefined {
  try {
    return window.localStorage.getItem(STORAGE_KEY) ?? undefined
  } catch {
    return undefined
  }
}

function write(firm: string): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, firm)
  } catch {
    // Depolama kapalıysa seçim yalnız bu oturumda hatırlanır.
  }
}

interface CashFirmState {
  /** Son seçilen firma anahtarı; yetki kontrolü `pickFirm`'dedir. */
  firm: string | undefined
  remember: (firm: string) => void
}

/** Nakit sayfaları arasında firma seçimini taşır; URL'deki `?firma=` her zaman önceliklidir. */
export const useCashFirmStore = create<CashFirmState>()((set, get) => ({
  firm: read(),
  remember: (firm) => {
    if (get().firm === firm) return
    write(firm)
    set({ firm })
  },
}))

/** URL'deki firma geçerliyse o; yoksa hatırlanan (hâlâ listedeyse); yoksa listenin ilk firması. */
export function pickFirm(
  wanted: string | undefined,
  remembered: string | undefined,
  keys: readonly string[],
): string | undefined {
  if (wanted && keys.includes(wanted)) return wanted
  if (remembered && keys.includes(remembered)) return remembered
  return keys[0]
}
